/* eslint-disable class-methods-use-this */
import { Location, LocationMapper } from '@nx-smartmonkey/shared/domain';
import { Requests } from '@nx-smartmonkey/shared/helpers';

import { SessionRepository } from '../session/SessionRepository';
import { GeocodingRepository } from './GeocodingRepository';

export class GeocodingRepositoryApi implements GeocodingRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async postGeocode({ addresses, projectId }: { addresses: string[]; projectId?: string }): Promise<Location[]> {
    const dataToSend: Record<string, any> = {
      addresses: addresses.map((dir: any) => (!dir || dir === `undefined` ? `` : dir)),
    };

    dataToSend.project_id = projectId ?? ``;

    const response = await this.requests.post({
      uri: `/maps/geocode/planner`,
      data: dataToSend,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });

    return response.data.map((location: any, idx: number) => {
      // Undefined as string parse.
      return LocationMapper.toDomain({
        ...location,
        original_input: addresses[idx] === `undefined` ? undefined : addresses[idx],
      });
    }) as Location[];
  }

  // TODO: getLocationFromCoordinates
}
